(function (document) {
  'use strict';

  if (typeof Object.assign !== 'function') {
    // .length of function is 2
    Object.assign = function (target, varArgs) {
      if (target === null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        // Skip over if undefined or null
        if (nextSource !== null) {
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    };
  }

  // Array.prototype.find ES6 polyfill for ES5 versions
  Array.prototype.find =
    Array.prototype.find ||
    function (callback) {
      if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      } else if (typeof callback !== 'function') {
        throw new TypeError('callback must be a function');
      }
      var list = Object(this);
      // Makes sures is always has an positive integer as length.
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      for (var i = 0; i < length; i++) {
        var element = list[i];
        if (callback.call(thisArg, element, i, list)) {
          return element;
        }
      }
    };

  window.AppConfig = {"mainNode":"app","enableLitElement":true,"initialBundle":["customers","error","tasks","web-app-start"],"appModules":["@gcbs","@gcbs-core","@gcbs-data-managers","@gcbs-web-components"],"prplLevel":1,"composerEndpoint":"./composerMocks/","componentsPath":"./bower_components/","pagesPath":"pages/","appPages":{"actionsOffice":"actions-office","apoderadoCreate":"apoderado-create","apoderadoRevoke":"apoderado-revoke","apoderados":"apoderados","bastantear":"bastantear","bastanteoCorrection":"bastanteo-correction","bastanteoList":"bastanteo-list","chargeCreate":"charge-create","chargeRevoke":"charge-revoke","customers":"customers","charges":"charges","documentaryInformation":"documentary-information","error":"error","facultyDetail":"faculty-detail","facultyList":"faculty-list","facultyGlobal":"faculty-global","facultyRevoke":"faculty-revoke","globalCustomerSituation":"global-customer-situation","groupCreate":"group-create","groupFacultyAdd":"group-faculty-add","groupList":"group-list","helps":"helps","jointFacultyAdd":"joint-faculty-add","jointSchemesAdd":"joint-schemes-add","legalDocuments":"legal-documents","login":"login","managementAgencyUsersAdd":"management-agency-users-add","managementAgencyUsers":"management-agency-users","managerNotesList":"manager-notes-list","managerNotesAdd":"manager-notes-add","mandataries":"mandataries","mandataryCreate":"mandatary-create","mandataryRevoke":"mandatary-revoke","membersAdd":"members-add","membersList":"members-list","observationsList":"observations-list","operationalRisk":"operational-risk","representatives":"representatives","requests":"requests","restrictionsAdd":"restrictions-add","restrictionsRevoke":"restrictions-revoke","revokeProtocol":"revoke-protocol","sharedDocuments":"shared-documents","sharedDocumentsAdd":"shared-documents-add","signatureSchemesCreate":"signature-schemes-create","signatureSchemesList":"signature-schemes-list","solidaryFacultyAdd":"solidary-faculty-add","specialFacultyAdd":"special-faculty-add","tasks":"tasks","trazabilityList":"trazability-list","updateDatesCharge":"update-dates-charge","webAppStart":"web-app-start"},"routes":{"actions-office":"/actions-office","apoderado-create":"/apoderado-create","apoderado-revoke":"/apoderado-revoke","apoderados":"/apoderados","bastantear":"/bastantear","bastanteo-correction":"/bastanteo-correction","bastanteo-list":"/bastanteo-list","charge-create":"/charge-create","charge-revoke":"/charge-revoke","customers":"/customers","charges":"/charges","documentary-information":"/documentary-information","error":"/error","faculty-detail":"/faculty-detail","faculty-list":"/faculty-list","faculty-global":"/faculties-global","faculty-revoke":"/faculty-revoke","global-customer-situation":"/global-customer-situation","group-create":"/create-group","group-faculty-add":"/group-faculty-add","group-list":"/group-list","helps":"/helps","joint-faculty-add":"/joint-faculty-add","joint-schemes-add":"/joint-schemes-add","legal-documents":"/legal-documents","login":"/gcbs-dev-auth","management-agency-users-add":"/management-agency-users-add","management-agency-users":"/management-agency-users","manager-notes-list":"/manager-notes-list","manager-notes-add":"/manager-notes-add","mandataries":"/mandataries","mandatary-create":"/create-mandatary","mandatary-revoke":"/revoke-mandatary","members-add":"/add-members","members-list":"/members","observations-list":"/observations-list","operational-risk":"/operational-risk","representatives":"/representatives","requests":"/requests","restrictions-add":"/restrictions-add","restrictions-revoke":"/restrictions-revoke","revoke-protocol":"/revoke-protocol","shared-documents":"/shared-documents","shared-documents-add":"/shared-documents-add","signature-schemes-create":"/create-signature-schemes","signature-schemes-list":"/signature-schemes","solidary-faculty-add":"/solidary-faculty-add","special-faculty-add":"/special-faculty-add","tasks":"/tasks","trazability-list":"/trazability-list","update-dates-charge":"/update-dates-charge","web-app-start":"/"},"transpile":true,"transpileExclude":["webcomponentsjs","moment","d3","bgadp*"],"locales":{"languages":["es-ES"],"intlInputFileNames":["locales"],"intlFileName":"locales","enabledI18n":false},"appVersion":"5.8.0-SNAPSHOT","debug":false,"logs":false,"semaas":{"architecture":true,"consumerId":"gcbs@com.bbva.es.channels","dnsTld":"platform.bbva.com","mrId":"gcbs","tsec2JWTEndpoint":"https://tsec2jwt.work.global.nextgen.igrupobbva/v1/Token","version":"v1","nameSpace":"es.gcbs.app-id-9219.pro","policy":"pro_bbva_es","region":"live-01"},"appConfig":{"httpHeaders":{"onsite-operationalBank":"0182","onsite-physicalBank":"0182","onsite-operationalBranch":"4991","onsite-physicalBranch":"4991"},"access":{"pages":{"tasks":[1,2,6,7],"customers":[1,2,3,4,5,6,7,8,9],"sharedDocuments":[1,2,6,7],"representatives":[1,2,3,4,5,6,7,8,9],"managementAgencyUsers":[5,7,9],"requests":[1,2,3,4,5,6,7,8,9],"legalDocuments":[7],"helps":[1,2,6,7]},"cmd":{"deleteLegalDocument":{"roles":[6,7],"status":["B","C","M","Q","T","O","X"]},"fixLegalDocument":{"roles":[6,7],"status":["B","C","M","Q","O"]},"reassignTask":[2,6,7],"sharedDocuments":[1,2,6,7],"remarks":[1,2,6,7],"deleteMergeAbsorptionOption":[1,2,6,7]}}},"appProperties":{"asoPath":"ASO2","country":"ES","grantingTicketPath":"ASO2/TechArchitecture/grantingTickets/V02","jsonWebTokenPath":"KSZM_JWT/kszm_kszm_01/tf/jwt/","lang":"es-ES","name":"Nueva Aplicación de Bastanteos","version":"5.8.0-SNAPSHOT","environment":"pro","host":"https://portalintranet.es.igrupobbva"},"engine":"polymer","once":true,"deployEndpoint":"","pageDefinitions":[{"name":"actions-office","adapter":"litElement","type":"static","hasModules":false},{"name":"apoderado-create","adapter":"litElement","type":"static","hasModules":false},{"name":"apoderado-revoke","adapter":"litElement","type":"static","hasModules":false},{"name":"apoderados","adapter":"litElement","type":"static","hasModules":false},{"name":"bastantear","adapter":"litElement","type":"static","hasModules":false},{"name":"bastanteo-correction","adapter":"litElement","type":"static","hasModules":false},{"name":"bastanteo-list","adapter":"litElement","type":"static","hasModules":false},{"name":"charge-create","adapter":"litElement","type":"static","hasModules":false},{"name":"charge-revoke","adapter":"litElement","type":"static","hasModules":false},{"name":"charges","adapter":"litElement","type":"static","hasModules":false},{"name":"customers","adapter":"litElement","type":"static","hasModules":false},{"name":"documentary-information","adapter":"litElement","type":"static","hasModules":false},{"name":"error","adapter":"litElement","type":"static","hasModules":false},{"name":"faculty-detail","adapter":"litElement","type":"static","hasModules":false},{"name":"faculty-global","adapter":"litElement","type":"static","hasModules":false},{"name":"faculty-list","adapter":"litElement","type":"static","hasModules":false},{"name":"faculty-revoke","adapter":"litElement","type":"static","hasModules":false},{"name":"global-customer-situation","adapter":"litElement","type":"static","hasModules":false},{"name":"group-create","adapter":"litElement","type":"static","hasModules":false},{"name":"group-faculty-add","adapter":"litElement","type":"static","hasModules":false},{"name":"group-list","adapter":"litElement","type":"static","hasModules":false},{"name":"helps","adapter":"litElement","type":"static","hasModules":false},{"name":"joint-faculty-add","adapter":"litElement","type":"static","hasModules":false},{"name":"joint-schemes-add","adapter":"litElement","type":"static","hasModules":false},{"name":"legal-documents","adapter":"litElement","type":"static","hasModules":false},{"name":"management-agency-users-add","adapter":"litElement","type":"static","hasModules":false},{"name":"management-agency-users","adapter":"litElement","type":"static","hasModules":false},{"name":"manager-notes-add","adapter":"litElement","type":"static","hasModules":false},{"name":"manager-notes-list","adapter":"litElement","type":"static","hasModules":false},{"name":"mandataries","adapter":"litElement","type":"static","hasModules":false},{"name":"mandatary-create","adapter":"litElement","type":"static","hasModules":false},{"name":"mandatary-revoke","adapter":"litElement","type":"static","hasModules":false},{"name":"members-add","adapter":"litElement","type":"static","hasModules":false},{"name":"members-list","adapter":"litElement","type":"static","hasModules":false},{"name":"observations-list","adapter":"litElement","type":"static","hasModules":false},{"name":"operational-risk","adapter":"litElement","type":"static","hasModules":false},{"name":"representatives","adapter":"litElement","type":"static","hasModules":false},{"name":"requests","adapter":"litElement","type":"static","hasModules":false},{"name":"restrictions-add","adapter":"litElement","type":"static","hasModules":false},{"name":"restrictions-revoke","adapter":"litElement","type":"static","hasModules":false},{"name":"revoke-protocol","adapter":"litElement","type":"static","hasModules":false},{"name":"shared-documents-add","adapter":"litElement","type":"static","hasModules":false},{"name":"shared-documents","adapter":"litElement","type":"static","hasModules":false},{"name":"signature-schemes-create","adapter":"litElement","type":"static","hasModules":false},{"name":"signature-schemes-list","adapter":"litElement","type":"static","hasModules":false},{"name":"solidary-faculty-add","adapter":"litElement","type":"static","hasModules":false},{"name":"special-faculty-add","adapter":"litElement","type":"static","hasModules":false},{"name":"tasks","adapter":"litElement","type":"static","hasModules":false},{"name":"trazability-list","adapter":"litElement","type":"static","hasModules":false},{"name":"update-dates-charge","adapter":"litElement","type":"static","hasModules":false},{"name":"web-app-start","adapter":"litElement","type":"static","hasModules":false}],"pages":["actions-office","apoderado-create","apoderado-revoke","apoderados","bastantear","bastanteo-correction","bastanteo-list","charge-create","charge-revoke","charges","customers","documentary-information","error","faculty-detail","faculty-global","faculty-list","faculty-revoke","global-customer-situation","group-create","group-faculty-add","group-list","helps","joint-faculty-add","joint-schemes-add","legal-documents","management-agency-users-add","management-agency-users","manager-notes-add","manager-notes-list","mandataries","mandatary-create","mandatary-revoke","members-add","members-list","observations-list","operational-risk","representatives","requests","restrictions-add","restrictions-revoke","revoke-protocol","shared-documents-add","shared-documents","signature-schemes-create","signature-schemes-list","solidary-faculty-add","special-faculty-add","tasks","trazability-list","update-dates-charge","web-app-start"]};
  window.AppComposerConfig = {};

  function removeSplashScreen() {
    var loadEl = document.getElementById('splash');
    if (loadEl) {
      loadEl.parentNode.removeChild(loadEl);
      document.body.classList.remove('loading');
    }
  }

  function continueLoading() {
    if (isLoadingInitialPage()) {
      fireComponentsLoadEvent();
    } else {
      loadAppElements(fireComponentsLoadEvent);
    }
  }

  function fireComponentsLoadEvent() {
    var eventComponentsLoaded = new CustomEvent('componentsLoaded');
    document.body.dispatchEvent(eventComponentsLoaded);
  }

  function onScriptLoadError(file, cb) {
    return function () {
      var customEvent = new CustomEvent('scriptLoadError', {
        detail: file,
      });
      document.body.dispatchEvent(customEvent);
      if (typeof cb === 'function') {
        cb();
      }
    };
  }

  function _importHtml(url, cb, async) {
    var loadAsync = typeof async !== 'undefined' ? async : false;
    var nextBundle = document.createElement('link');
    nextBundle.rel = 'import';
    nextBundle.href = url;
    nextBundle.addEventListener('load', cb);
    nextBundle.addEventListener('error', onScriptLoadError(nextBundle.href, cb));
    if (loadAsync) {
      nextBundle.setAttribute('async', '');
    }
    document.head.appendChild(nextBundle);
  }

  function _importScript(url, cb, isModule) {
    var nextBundle = document.createElement('script');
    if (isModule) {
      nextBundle.type = 'module';
    }
    nextBundle.src = url;
    nextBundle.addEventListener('load', cb);
    nextBundle.addEventListener('error', onScriptLoadError(nextBundle.href, cb));

    document.head.appendChild(nextBundle);
  }

  function loadInitialPolymerComponents(cb) {
    _importHtml(window.AppConfig.deployEndpoint + window.AppConfig.componentsPath + 'initial-components.html', cb);
  }

  function loadAppPolymerComponents(cb) {
    _importHtml(window.AppConfig.deployEndpoint + window.AppConfig.componentsPath + 'app-components.html', cb, true);
  }

  function loadScriptsBundle(bundle, cb) {
    var scripts = window.AppConfig.bundles[bundle];
    var pendingTasks = scripts.length;
    var i;

    var taskCompleted = function () {
      pendingTasks--;
      if (pendingTasks === 0) {
        if (typeof cb === 'function') {
          cb();
        }
      }
    };
    for (i = 0; i < scripts.length; i++) {
      _importScript(scripts[i], taskCompleted, false);
    }
  }

  function loadFirstScripts(cb) {
    loadScriptsBundle('initial', cb);
  }

  function loadRestScripts(cb) {
    var scripts = window.AppConfig.bundles['rest'];
    if (scripts.length === 0) {
      scripts.push(window.AppConfig.deployEndpoint + './lit-components.js');
    }
    loadScriptsBundle('rest', cb);
  }

  const loadFirstBundle = (cb) => {
    import('./lit-initial-components.js').then(() => (typeof cb === 'function' ? cb() : ''));
  };

  const loadRestBundle = (cb) => {
    import('./lit-components.js').then(() => (typeof cb === 'function' ? cb() : ''));
  };

  function loadInitialLitElementComponents(cb) {
    if (window.AppConfig.onlyLitElements && window.AppConfig.devmode) {
      _importScript(window.AppConfig.deployEndpoint + 'scripts/lit-initial-components.js', cb, true);
    } else {
      if (window.AppConfig.bundles) {
        loadFirstScripts(cb);
      } else {
        if (window.AppConfig.onlyLitElements) {
          loadFirstBundle(cb);
        } else {
          _importHtmlWithModules(
            window.AppConfig.deployEndpoint + 'lit-initial-components.html',
            'lit-initial-components-loaded',
            cb
          );
        }
      }
    }
  }

  function _importHtmlWithModules(url, eventName, cb) {
    var nextBundle = document.createElement('link');
    nextBundle.rel = 'import';
    nextBundle.href = url;
    nextBundle.addEventListener('error', onScriptLoadError(nextBundle.href, cb));
    document.body.addEventListener(eventName, cb, { once: true });
    document.head.appendChild(nextBundle);
  }

  function loadAppLitComponents(cb) {
    if (window.AppConfig.onlyLitElements && window.AppConfig.devmode) {
      _importScript(window.AppConfig.deployEndpoint + 'scripts/lit-components.js', cb, true);
    } else {
      if (window.AppConfig.bundles) {
        loadRestScripts(cb);
      } else {
        if (window.AppConfig.onlyLitElements) {
          loadRestBundle(cb);
        } else {
          _importHtml(window.AppConfig.deployEndpoint + 'lit-components.html', cb, true);
        }
      }
    }
  }

  function loadInitialElements() {
    if (window.AppConfig.onlyLitElements) {
      loadInitialLitElementComponents(continueLoading);
    } else {
      loadInitialPolymerComponents(function () {
        if (window.AppConfig.enableLitElement) {
          loadInitialLitElementComponents(continueLoading);
        } else {
          continueLoading();
        }
      });
    }
  }

  function loadAppElements(cb) {
    if (window.AppConfig.onlyLitElements) {
      loadAppLitComponents(cb);
    } else {
      loadAppPolymerComponents(function () {
        if (window.AppConfig.enableLitElement) {
          loadAppLitComponents(cb);
        } else {
          if (cb && typeof cb === 'function') {
            cb();
          }
        }
      });
    }
  }

  function isLoadingInitialPage() {
    var initialPage;
    var hash;
    var isInitialPage = true;
    if (window.AppConfig.initialBundle && window.AppConfig.initialBundle.length > 0) {
      hash = window.location.hash;
      if (hash === '' || hash === '#!/') {
        isInitialPage = true;
      } else {
        initialPage = window.AppConfig.initialBundle[0].split('.')[0];
        isInitialPage = hash.indexOf(initialPage) > -1;
      }
    }

    return isInitialPage;
  }

  function onNavigation(msg) {
    var customEvent = new CustomEvent('aria-announce', {
      detail: msg.detail.detail.page,
    });
    document.body.dispatchEvent(customEvent);
  }

  function onAnnounce(msg) {
    var announcer = document.querySelector('#announcer');
    if (announcer) {
      announcer.textContent = msg.detail;
    }
  }

  function detectPlatform(which, orelse) {
    return 'desktop';
  }

  //TODO: write a proper platform detection
  function getPlatform() {
    return detectPlatform('ios', detectPlatform('android', 'desktop'));
  }

  function shouldAddCordovaScript(config) {
    var userAgent = window.navigator.userAgent.toLowerCase();
    var ios = /iphone|ipod|ipad/.test(userAgent);
    var android = /android/.test(userAgent);
    var safari = /safari/.test(userAgent);
    var webViewWv = / wv\)/.test(userAgent);
    var crosswalk = /crosswalk/.test(userAgent);

    if (!config.cordovaScript) {
      return false;
    }

    if (ios) {
      return !safari;
    }

    if (android) {
      return webViewWv || crosswalk;
    }
  }

  function appendCordovaScript() {
    var script = document.createElement('script');
    script.setAttribute('src', window.AppConfig.cordovaScript);
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('charset', 'utf-8');
    script.onerror = onScriptLoadError(window.AppConfig.cordovaScript);
    document.body.appendChild(script);
  }

  function generateRequestHeaders() {
    var composerHeader = {};
    if (window.AppConfig.composerHeaderKey && window.AppConfig.composerHeaderValue) {
      composerHeader[window.AppConfig.composerHeaderKey] = window.AppConfig.composerHeaderValue;
    }
    return composerHeader;
  }

  function onRender(template, fixed) {
    if (!template.parentNode) {
      document.getElementById(this.mainNode).appendChild(template);
      var componentsInTemplateLoaded = new CustomEvent('componentsInTemplateLoaded');
      document.body.dispatchEvent(componentsInTemplateLoaded);
    }
    if (fixed) {
      document.getElementById('external__header').innerHTML = '';
      document.getElementById('external__footer').innerHTML = '';
      fixed.forEach(function (component) {
        document.getElementById(component.zone).appendChild(component.node);
      });
    }
  }

  function startCore(options) {
    const sc = function () {
      var reference = getBridgeEngineReference(options);

      if (reference) {
        new reference(options);
      } else {
        console.log('Error instantiating core');
        setTimeout(sc, 1000);
      }
    };
    return sc;
  }

  function getBridgeEngineReference(options) {
    var enginesNamespace = { polymer: 'CellsPolymerBridge', native: 'CellsNativeBridge' };
    var defaultEngine = 'polymer';
    var engine = (options.engine || defaultEngine).toLowerCase();

    if (!enginesNamespace[engine]) {
      engine = defaultEngine;

      console.warn('Invalid value for AppConfig.engine. Using ' + defaultEngine);
    }

    var engineReference = enginesNamespace[engine];

    return window[engineReference];
  }

  function webComponentsSupported() {
    return window.customElements && 'content' in document.createElement('template');
  }

  function proxyCustomElements() {
    var _customElementsDefine = window.customElements.define;

    window.customElements.define = function (name, cl, conf) {
      if (!customElements.get(name)) {
        _customElementsDefine.call(window.customElements, name, cl, conf);
      } else {
        console.warn(name + 'has been defined twice');
      }
    };

    loadInitialElements();
  }

  window.CellsPolymer = {
    start: function (options) {
      var config = Object.assign(
        {
          binding: 'currentview',
          cache: window.AppConfig.coreCache || false,
          domMode: 'shadow',
          headers: generateRequestHeaders(),
          mainNode: 'app__content',
          onRender: onRender,
          getPlatform: getPlatform,
          preCache: false,
          preRender: false,
          loadAppElements: loadAppElements,
        },
        window.AppConfig,
        options,
        AppComposerConfig
      );

      var onNavigation = config.onNavigation || onNavigation;
      var removeSplash = config.removeSplashScreen || removeSplashScreen;

      window.Polymer = window.Polymer || {
        dom: config.domMode,
        lazyRegister: 'max',
        useNativeCSSProperties: true,
      };

      document.body.addEventListener('aria-announce', onAnnounce);
      document.body.addEventListener('componentsInTemplateLoaded', removeSplash, { once: true });
      if (config.initialBundle && isLoadingInitialPage() && !window.AppConfig.loadBundleOnDemand) {
        document.body.addEventListener('componentsInTemplateLoaded', loadAppElements, { once: true });
      }
      document.body.addEventListener('componentsLoaded', startCore(config), { once: true });

      if (options.enableSSLPinning) {
        document.body.addEventListener('componentsLoaded', options.enableSSLPinning, { once: true });
      }

      document.getElementById(config.mainNode).addEventListener('nav-request', onNavigation);

      if (shouldAddCordovaScript(config)) {
        appendCordovaScript();
      }

      if (!config.skipInitialLoad) {
        this.ensureWebComponentsSupport();
      }
    },
    ensureWebComponentsSupport: function () {
      if (webComponentsSupported() && window.AppConfig.onlyLitElements) {
        proxyCustomElements();
      }
      if (!window.AppConfig.onlyLitElements && !('import' in document.createElement('link'))) {
        loadWebComponentPolyfill();
      }
    },
  };
  function loadWebComponentPolyfill() {
    var url = 'none';
    if (window.AppConfig.onlyLitElements) {
      url = window.AppConfig.deployEndpoint + 'scripts/webcomponentsjs/webcomponents-hi.js';
    } else {
      url = window.AppConfig.deployEndpoint + window.AppConfig.componentsPath + 'webcomponentsjs/webcomponents-hi.js';
    }

    var polyfill = document.createElement('script');
    polyfill.src = url;
    polyfill.addEventListener('load', proxyCustomElements);
    polyfill.addEventListener('error', onScriptLoadError(polyfill.src));
    document.head.appendChild(polyfill);
  }
})(document);
